import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalFooter , ModalHeader } from 'reactstrap';
import { connect } from 'react-redux';


class NewModalBase extends Component {

	constructor(props) {
	    super(props);
		    this.state = {
		    modal: false,
		};
		this.toggleModal = this.toggleModal.bind(this);
	}
	static modals = [];
    static open = (id) => (e) => {
        e.preventDefault();
        let modal = NewModalBase.modals.find(x => x.props.id === id);
        modal.setState({ modal: true });
    }

    static eventClose = (id) => (e) => {
        e.preventDefault();

        let modal = NewModalBase.modals.find(x => x.props.id === id);
        modal.setState({ modal: false });
    }

    static close = (id) => {
        let modal = NewModalBase.modals.find(x => x.props.id === id);
        modal.setState({ modal: false });
    }

    componentDidMount() {
        NewModalBase.modals.push(this);
    }

    componentWillUnmount() {
        NewModalBase.modals = NewModalBase.modals.filter(x => x.props.id !== this.props.id);
    }

    acceptButton() {
    	if(this.props.confirmFunc){
			this.props.confirmFunc();
			NewModalBase.close(this.props.id);
		}
		else
			NewModalBase.close(this.props.id);
    }
	toggleModal() {
	    this.setState({
	      modal: !this.state.modal,
	    });
	}
	render () {
		return (
			<Modal id={this.props.id} isOpen={this.state.modal} toggle={this.toggleModal} className={this.props.className ? this.props.className : '' }>
				<ModalHeader toggle={this.toggleModal}>{this.props.title? this.props.title : '' }</ModalHeader>
				<ModalBody>
					{ this.props.html }
				</ModalBody>
				{
					this.props.confirmFunc ?
						<ModalFooter>
							<Button 
								color = "primary" 
								style={this.props.bg_company?this.props.bg_company:undefined} 
								disabled={this.props.preloader ===true?true:false} 
								onClick = { this.acceptButton.bind(this) } > 
								{this.props.json_lang.common.save} 
								</Button>
							<Button color = "secondary" onClick = { NewModalBase.eventClose(this.props.id) } > {this.props.json_lang.common.cancel} </Button>
						</ModalFooter>
					:
					null
				}
				
			</Modal>
		)
		
	}
}
const mapStateToProps = (state) => {
	return {
		errors: state.errors,
		admin: state.admin,
		json_lang: state.json_lang,
		preloader: state.preloader,
		bg_company:{ 
			background: state.company_styles_json.color_accent,
			borderColor: state.company_styles_json.color_accent,
		},
		btn_link:{ color: state.company_styles_json.color_accent},
	}
}


export default connect(mapStateToProps)(NewModalBase);


// WEBPACK FOOTER //
// ./src/views/Plugins/MainModals/NewModalBase.jsx